import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { DateUtilProvider } from '@starley/ion-directives';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomComponentModule } from './components/components.module';
import { CnpjPipe } from './pipes/cnpj.pipe';
import { CpfPipe } from './pipes/cpf.pipe';
import { PrecoVendaPipe } from './pipes/preco-venda.pipe';
import { SortbyPipe } from "./pipes/sortby.pipe";
import { FcmFirebaseProvider } from './provider/fcmFirebase.provider';
import { OneSignalProvider } from './provider/oneSignal.provider';
import { ActivationListService } from './services/activation-service/activation-list.service';
import { ActivationPreService } from './services/activation-service/activation-pre.service';
import { GoogleAnalyticsService } from './services/analitytics-service/google-analytics.service';
import { AndroidService } from './services/android-permissions/android-permission.service';
import { LoginService } from './services/auth/login.service';
import { PasswordValidatorService } from './services/auth/password-validador.service';
import { ResetPwdService } from './services/auth/reset-pwd.service';
import { SafetyService } from './services/auth/safety.service';
import { ValidateIdentityService } from './services/auth/validate-identity.service';
import { BannerService } from './services/banner-service/banner.service';
import { BarcodeScannerService } from './services/barcode-scanner/barcode-scanner.service';
import { ModelLocatorService } from './services/config/model-locator.service';
import { RemoteConfigService } from './services/config/remote-config.service';
import { GuardService } from './services/guard/guard.service';
import { HttpService } from './services/http-service/http.service';
import { ImageService } from './services/image-service/image.service';
import { MessageService } from './services/message-service/message.service';
import { PostService } from './services/post-service/post.service';
import { ProfileService } from './services/profile-service/profile.service';
import { QualityService } from './services/quality-service/quality.service';
import { UpdateAppOtaService } from './services/update/update-app.service';
import { UtilService } from './services/util/util.service';

@NgModule({
    declarations: [AppComponent],
    imports: [BrowserModule,
        IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }),
        AppRoutingModule,
        ReactiveFormsModule,
        CustomComponentModule,
        HttpClientModule],
    providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        HttpService,
        DateUtilProvider,
        GuardService,
        AndroidService,
        GoogleAnalyticsService,
        FcmFirebaseProvider,
        OneSignalProvider,
        HttpClient,
        LoginService,
        ResetPwdService,
        ModelLocatorService,
        MessageService,
        PostService,
        BannerService,
        UtilService,
        ProfileService,
        PrecoVendaPipe,
        CnpjPipe,
        CpfPipe,
        SortbyPipe,
        PasswordValidatorService,
        QualityService,
        ActivationListService,
        ActivationPreService,
        BarcodeScannerService,
        ImageService,
        SafetyService,
        ValidateIdentityService,
        RemoteConfigService,
        UpdateAppOtaService
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
